import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "ai-cards" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Persona = _resolveComponent("Persona")
  const _component_Company = _resolveComponent("Company")
  const _component_Meeting = _resolveComponent("Meeting")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.cards, (card, ind) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: ind }, [
        (card.type === 'persona')
          ? (_openBlock(), _createBlock(_component_Persona, {
              key: 0,
              persona: card,
              loading: $props.loading,
              idx: ind,
              readonly: $props.readonly
            }, null, 8 /* PROPS */, ["persona", "loading", "idx", "readonly"]))
          : (card.type === 'company')
            ? (_openBlock(), _createBlock(_component_Company, {
                key: 1,
                company: card,
                loading: $props.loading,
                idx: ind,
                readonly: $props.readonly
              }, null, 8 /* PROPS */, ["company", "loading", "idx", "readonly"]))
            : (card.type === 'meeting')
              ? (_openBlock(), _createBlock(_component_Meeting, {
                  key: 2,
                  meeting: card,
                  loading: $props.loading,
                  idx: ind,
                  readonly: $props.readonly
                }, null, 8 /* PROPS */, ["meeting", "loading", "idx", "readonly"]))
              : _createCommentVNode("v-if", true)
      ], 64 /* STABLE_FRAGMENT */))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}